module.exports = __webpack_public_path__ + "img/logo-riv.761a81fd.svg";